import React from "react";
import { STATUTORY_KYC_CONST } from "../statutory-kyc-const";
import {
  Box,
  Col,
  Dialog,
  InputField,
  Row,
  SelectField,
  Switchbox,
} from "../../../../ppui";

const EpfupdateModal = ({
  EmployeeEPF,
  epfmodal,
  onChanageEPF,
  OnBlureEPF,
  ToggleEPF,
  errorsEPF,
  orginfo,
  TogggleEpfMOdal,
  UpdateStatutory,
  updateLoder,
}) => {
  return (
    <Dialog
      title="Employee Under EPF Scheme"
      secondary={` Code: ${orginfo?.epfOrganizationNumber}`}
      closeButton={true}
      fullWidth
      maxWidth="sm"
      open={epfmodal}
      onClose={TogggleEpfMOdal}
      onSubmit={UpdateStatutory}
      btnLoading={updateLoder}
      separator
      buttonName="Update"
      footer={
        <>
          <Box mr={"auto"}>
            <Switchbox
              disabled={!orginfo?.epfOrganizationIsDisabled}
              label={` ${EmployeeEPF?.epf_availability ? "Disable" : "Enable"} EPF`}
              color="Primary"
              size="lg"
              name="epf_availability"
              checked={EmployeeEPF?.epf_availability}
              onChange={ToggleEPF}
            />
          </Box>
        </>
      }
    >
      <Row rowGap>
        <Col xs={12} sm={6}>
          <SelectField
            error={!!errorsEPF?.member_payroll}
            helperText={errorsEPF?.member_payroll}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.member_payroll}
            defaultValue={EmployeeEPF?.member_payroll}
            onChange={(e) => onChanageEPF(e, "member_payroll")}
            onBlur={(e) => OnBlureEPF(e, "member_payroll")}
            {...STATUTORY_KYC_CONST.member_payroll}
          />
        </Col>
        {EmployeeEPF?.member_payroll && (
          <Col xs={12} sm={6}>
            <InputField
              error={!!errorsEPF?.epf_id_ac_no}
              helperText={errorsEPF?.epf_id_ac_no}
              disabled={!EmployeeEPF?.epf_availability}
              valueSinc={!!EmployeeEPF?.epf_id_ac_no}
              value={EmployeeEPF?.epf_id_ac_no}
              onChange={(e) => onChanageEPF(e, "epf_id_ac_no")}
              onBlur={(e) => OnBlureEPF(e, "epf_id_ac_no")}
              {...STATUTORY_KYC_CONST.epf_id_ac_no}
            />
          </Col>
        )}

        <Col xs={12} sm={6}>
          <InputField
            error={!!errorsEPF?.uan_no}
            helperText={errorsEPF?.uan_no}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.uan_no}
            value={EmployeeEPF?.uan_no}
            onChange={(e) => onChanageEPF(e, "uan_no")}
            onBlur={(e) => OnBlureEPF(e, "uan_no")}
            {...STATUTORY_KYC_CONST.uan_no}
          />
        </Col>

        <Col xs={12} sm={6}>
          <SelectField
            error={!!errorsEPF?.employee_contribution}
            helperText={errorsEPF?.employee_contribution}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.employee_contribution}
            defaultValue={EmployeeEPF?.employee_contribution}
            onChange={(e) => onChanageEPF(e, "employee_contribution")}
            onBlur={(e) => OnBlureEPF(e, "employee_contribution")}
            {...STATUTORY_KYC_CONST.employee_contribution}
          />
        </Col>

        <Col xs={12} sm={6}>
          <SelectField
            error={!!errorsEPF?.retired_govt_employee}
            helperText={errorsEPF?.retired_govt_employee}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.retired_govt_employee}
            defaultValue={EmployeeEPF?.retired_govt_employee}
            onChange={(e) => onChanageEPF(e, "retired_govt_employee")}
            onBlur={(e) => OnBlureEPF(e, "retired_govt_employee")}
            {...STATUTORY_KYC_CONST.retired_govt_employee}
          />
        </Col>
        {EmployeeEPF?.retired_govt_employee && (
          <Col xs={12} sm={6}>
            <InputField
              error={!!errorsEPF?.ppo_no}
              helperText={errorsEPF?.ppo_no}
              disabled={!EmployeeEPF?.epf_availability}
              valueSinc={!!EmployeeEPF?.ppo_no}
              value={EmployeeEPF?.ppo_no}
              onChange={(e) => onChanageEPF(e, "ppo_no")}
              onBlur={(e) => OnBlureEPF(e, "ppo_no")}
              {...STATUTORY_KYC_CONST.ppo_no}
            />
          </Col>
        )}

        <Col xs={12} sm={6}>
          <InputField
            error={!!errorsEPF?.epf_registration_date}
            helperText={errorsEPF?.epf_registration_date}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.epf_registration_date}
            value={EmployeeEPF?.epf_registration_date}
            onChange={(e) => onChanageEPF(e, "epf_registration_date")}
            onBlur={(e) => OnBlureEPF(e, "epf_registration_date")}
            onKeyDown={(e) => e.preventDefault()}
            {...STATUTORY_KYC_CONST.epf_registration_date}
          />
        </Col>

        <Col xs={12} sm={6}>
          <InputField
            error={!!errorsEPF?.epf_uan_attachment}
            helperText={
              EmployeeEPF?.epf_uan_attachment?.name ||
              EmployeeEPF?.epf_uan_attachment?.slice(0, 14)
            }
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.epf_uan_attachment}
            onChange={(e) => onChanageEPF(e, "epf_uan_attachment", "file")}
            onBlur={(e) => OnBlureEPF(e, "epf_uan_attachment")}
            {...STATUTORY_KYC_CONST.epf_uan_attachment}
          />
        </Col>
      </Row>
    </Dialog>
  );
};

export default EpfupdateModal;
